module.exports = "/_next/static/images/papara-4ffac2a1166e3368336c6afdb44ddd14.png";